import $ from 'jquery';

import { $Elements, Classes, Elements, Events } from '../global/constants';
import { ajax } from '../global/helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Newsletter ----------

	if(typeof newsletter_params !== 'undefined') {

		$('form.newsletter-form').each(function() {

			const form = $(this);
			const input = form.find('input[type=email]');
			const button = form.find('button[type=submit]');
			const tooltip = form.find('.invalid-tooltip');

			const turnstileContainer = form[0].querySelector('.turnstile-widget');

			if(turnstileContainer && newsletter_params.turnstile_sitekey) {

				const renderTurnstile = () => turnstile.render(turnstileContainer, { sitekey: newsletter_params.turnstile_sitekey, theme: 'light' });

				if(typeof turnstile !== 'undefined') {
					renderTurnstile();
				}
				else {
					// Le script Cloudflare est chargé en async : sur un accès direct à la page il peut ne
					// pas être prêt au page.enter. On attend qu'il le soit avant de rendre le widget.
					const turnstileReady = setInterval(() => {
						if(typeof turnstile !== 'undefined') {
							clearInterval(turnstileReady);
							renderTurnstile();
						}
					}, 100);

					setTimeout(() => clearInterval(turnstileReady), 10000);
				}
			}

			form.on('submit', async e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				// L'input caché cf-turnstile-response n'est rempli qu'une fois le défi résolu
				if(turnstileContainer) {
					const turnstileInput = form.find('input[name="cf-turnstile-response"]');
					if(!turnstileInput.length || !turnstileInput.val()) {
						turnstileContainer.scrollIntoView({ block: 'center', behavior: 'smooth' });
						return false;
					}
				}

				input.removeClass('is-invalid');
				button.attr('disabled', true);
				Elements.LoadingBar.classList.add(Classes.loading);

				const formData = new FormData(form[0]);
				formData.append('action', newsletter_params.action);
				formData.append('nonce', newsletter_params.nonce);

				try {

					const response = await ajax({
						url: newsletter_params.url,
						type: 'POST',
						dataType: 'json',
						data: formData,
						processData: false,
						contentType: false,
					});

					form.empty();
					form.append('<div class="success-message"><span>' + response.data.message + '</span></div>')
				}
				catch(e) {

					if(e.data.error) {
						tooltip.text(e.data.error);
						input.addClass('is-invalid');
					}
				}

				button.attr('disabled', false);
				Elements.LoadingBar.classList.remove(Classes.loading);

				return false;
			});
		});
	}
});
